import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventsHttpService } from '../../services/events.http.service';
import { Observable, of, switchMap } from 'rxjs';
import { EventResponseEvent } from '../../types/event-response.type';

@Component({
  selector: 'app-event-single-page',
  templateUrl: './event-single-page.component.html',
  styleUrls: ['./event-single-page.component.scss'],
})
export class EventSinglePageComponent {
  public event$: Observable<EventResponseEvent | null> = this.route.params.pipe(
    switchMap((data) => {
      const eventId: number | null = data['event_id'] ?? null;

      if (eventId) {
        return this.eventsHttpService.getEvent(eventId);
      }

      return of(null);
    })
  );

  constructor(
    private route: ActivatedRoute,
    private eventsHttpService: EventsHttpService
  ) {}
}
